let FormPage = () => {
	SetGroup();
	

	return null;
};

let SetGroup = () => {
	var sections = document.getElementsByTagName("fieldset");
	[...sections].forEach((element) => {
		let legend = element.getElementsByTagName("legend")[0];
		if (legend != undefined) {
			element.classList.add("form-section");
		}
	});
};
export default FormPage;
